import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=1be27d11&"
import script from "./ShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1be27d11')) {
      api.createRecord('1be27d11', component.options)
    } else {
      api.reload('1be27d11', component.options)
    }
    module.hot.accept("./ShoppingCart.vue?vue&type=template&id=1be27d11&", function () {
      api.rerender('1be27d11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ShoppingCart.vue"
export default component.exports